import { RequestState } from '@containers/App/model';

import {
  Action,
  ActionTypes,
  IAddToCartButtonDefaultState,
  IAddToCartButtonState,
} from './model';

export const defaultState: IAddToCartButtonDefaultState = {
  sendState: RequestState.DEFAULT,
  submitAttempts: 0,
  mouseOverBuyButton: false,
};

export const reducer = (
  state: IAddToCartButtonState,
  action: Action
): IAddToCartButtonState => {
  switch (action.type) {
    case ActionTypes.INCREASE_SUBMIT_ATTEMPTS: {
      return {
        ...state,
        sendState:
          state.submitAttempts === 0
            ? RequestState.IN_PROGRESS
            : RequestState.RETRYING,
        submitAttempts: state.submitAttempts + 1,
      };
    }
    case ActionTypes.SET_MOUSE_OVER_BUY_BUTTON: {
      if (state.mouseOverBuyButton) {
        return state;
      }
      return { ...state, mouseOverBuyButton: true };
    }
    case ActionTypes.HANDLE_FAILED_ADD_TO_CART: {
      return {
        ...state,
        sendState: RequestState.FAILED,
      };
    }
    case ActionTypes.HANDLE_SUCCESS_ADD_TO_CART: {
      return {
        ...state,
        submitAttempts: 0,
        sendState: RequestState.DONE,
      };
    }
    case ActionTypes.UPDATE_STATE_AFTER_PROP_CHANGE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
